import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PayrollGroupService } from '../payroll-group.service';
import { PayrollGroupModel } from '../model/payroll-group.model';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-payroll-group-edit',
  templateUrl: './payroll-group-edit.component.html',
  styleUrls: ['./payroll-group-edit.component.scss'],
  standalone: false
})
export class PayrollGroupEditComponent implements DirtyCheck, OnInit {
  title: string = "New Payroll Group";
  editForm: FormGroup;
  payrollGroupInfo: PayrollGroupModel = {};
  isFormDirty: boolean = false;
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private payrollGroupService: PayrollGroupService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog
  ) {
    let payrollGroupId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.payrollGroupInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.payrollGroupInfo.name, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.payrollGroupInfo.description)
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (payrollGroupId !== null && parseInt(payrollGroupId) !== 0) {
      this.setPayrollGroupInfo(payrollGroupId);
    }
    this.permission = this.permissionService.getPagePermission('payroll-group');

  }

  ngOnInit(): void { }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/payroll/payroll-group']);
  }

  setPayrollGroupInfo(payrollGroupId: any): void {
    this.payrollGroupService.getById(payrollGroupId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          // Adjust according to your API response structure
          this.payrollGroupInfo = response.data.payroll_group;
          this.editForm.patchValue(this.payrollGroupInfo);
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  getTitle(): string {
    if (!this.payrollGroupInfo || this.payrollGroupInfo.id == null) {
      return "New Payroll Group";
    }
    return this.payrollGroupInfo.id == 0
      ? "New Payroll Group"
      : "Editing : " + this.payrollGroupInfo.name;
  }

  save(): void {
    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      Object.assign(this.payrollGroupInfo, this.editForm.value);
      this.payrollGroupService.update(this.payrollGroupInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            let snackBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.payrollGroupInfo.name + " has been updated successfully."
            }
            this.snackBarService.openSnackBar(snackBarData);
            this.router.navigate(['/payroll/payroll-group']);
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
